export default "__VITE_ASSET__ihhzeSng__"